import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "DiagnosticReport"*/ './lazyIndex'),
    { name: 'DiagnosticReport' }
);

export const lazyAppendInteractiveDiagnosticReportToMessage: LazyAction<
    typeof lazyIndex.appendInteractiveDiagnosticReportToMessage,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.appendInteractiveDiagnosticReportToMessage);
export const lazyAppendDiagnosticReportToMessage: LazyAction<
    typeof lazyIndex.appendDiagnosticReportToMessage,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.appendDiagnosticReportToMessage);
export const lazyGenerateInteractiveDiagnosticReport: LazyAction<
    typeof lazyIndex.generateInteractiveDiagnosticReport,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.generateInteractiveDiagnosticReport);
export const lazyRegisterAddDiagnosticCallback: LazyImport<
    typeof lazyIndex.registerAddDiagnosticCallback,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.registerAddDiagnosticCallback);
export const lazyInitializeHighMemoryBeaconListener: LazyAction<
    typeof lazyIndex.initializeHighMemoryBeaconListener,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeHighMemoryBeaconListener);
